import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { HelperWrapper, MainContainer } from 'src/components'
import { ETranslationNs } from 'src/types'

const ConsumerChallengesScreen = () => {
  return (
    <MainContainer
      headerTitle={<HelperWrapper t="challenges-header-title" ns={ETranslationNs.Navbar} />}
      // withAccountIcon
      // withScanBtn
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Typography sx={{ margin: '100px auto', fontSize: '36px' }}>Coming soon</Typography>
      </Box>
    </MainContainer>
  )
}

export default ConsumerChallengesScreen
